import createComponent from "@/utils/create-component"
import EmailPreferencesPage from "@/pages/email-preferences/index"

createComponent({
  el: "#vue-email-preferences",
  component: EmailPreferencesPage
})
